import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  addFormResponses,
  deleteFormResponses,
} from 'src/store/intake_forms/actions';

const FormRequestHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return addFormResponses(items);
    case EVENTS.REMOVE:
    default:
      return deleteFormResponses(items);
  }
};

export default FormRequestHandler;
